import { useCallback, useEffect, useState } from 'react';
import { useSaveSection } from './useSaveSection';

// Fetches one dashboard section's array on mount, keeps an optimistic local
// copy, and saves the whole array on every change - the read+write pair
// each of Socials/Portfolio/Collaborations (and their New/Edit pages) need,
// since each page now owns its own section instead of reading it off one
// shared blob. setItems returns the save's promise so a page that navigates
// away right after a mutation can await it first.
export function useOwnedSection(fetcher, endpoint, buildPayload) {
  const [items, setItemsState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const save = useSaveSection(endpoint);

  useEffect(() => {
    let cancelled = false;
    fetcher()
      .then((data) => {
        if (cancelled) return;
        setItemsState(data);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setItems = useCallback(
    (updater) => {
      const next = typeof updater === 'function' ? updater(items) : updater;
      setItemsState(next);
      return save(() => buildPayload(next));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items, save]
  );

  return { items, setItems, loading, error };
}
